// DS: DS4.3
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import s from './MainToggle.scss';
/**
 * A switch/toggle.
 *
 * `aria-label` or `aria-labelledby` is required since this component doesn't have a text label in the specification. If you
 * see a type error mention one of these, please add one depending on context.
 */
var MainToggle = function (_a) {
    var id = _a.id, value = _a.value, size = _a.size, hasError = _a.hasError, disabled = _a.disabled, biData = _a.biData, innerRef = _a.innerRef, onChange = _a.onChange, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"];
    var isDisabled = disabled || hasError;
    return (React.createElement(PlainButtonOrLink, { id: id, className: c(s['root'], value ? s['on'] : s['off'], isDisabled && s['disabled'], hasError && s['error'], s[size]), innerRef: innerRef, onClick: function () { return onChange(!value); }, biData: biData, disabled: isDisabled, "aria-pressed": value, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy },
        React.createElement("span", { className: s['dot'] }, hasError && React.createElement("span", { className: s['dot-line'] }))));
};
MainToggle.displayName = 'MainToggle';
export default MainToggle;
//# sourceMappingURL=MainToggle.js.map